import {
  Button,
  Flex,
  Icon,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { WHITE, YELLOWMONEDD } from "../../../constants/colors";

interface IMenu {
  link: string;
  text: string;
  iconArrow?: any;
  image?: any;
}

export default function SideBarMenuItem(props: IMenu) {
  return (
    <Link to={props.link} style={{ width: "100%" }}>
      <Flex
        _hover={{ bg: "#4B4B57", color: "blue.200", width: "99%" }}
        justifyContent={"flex-start"}
        // mb={"2"}
        borderBottom={"1px solid #FFFFFF"}
        textDecoration={"none"}
        w={"100%"}
        textAlign="center"
        alignItems={"center"}
        h="5vh"
        color={WHITE}
        cursor="pointer"
        px={"7"}
        transition="all .2s ease-in-out"
      >
        <Image
          boxSize="1.6rem"
          src={props.image}
          alt="Tela icone inicio"
          mr="19px"
        />
        {/* <Icon as={props.icon} size={"50px"} h={"50%"} color={YELLOWMONEDD} mr={"2vw"} /> */}
        <Text fontSize={"1rem"} fontWeight={"bold"}>
          {props.text}
        </Text>
        {props.iconArrow ? (
          <Icon
            as={props.iconArrow}
            size={"50px"}
            h={"50%"}
            color={YELLOWMONEDD}
            mr={"2vw"}
          />
        ) : (
          <></>
        )}
      </Flex>
    </Link>
  );
}
